/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { OrderStatus } from './OrderStatus';
// @ts-ignore
import {
// @ts-ignore
    OrderStatusFromJSON,
// @ts-ignore
    OrderStatusFromJSONTyped,
// @ts-ignore
    OrderStatusToJSON,
} from './OrderStatus';

/**
 * 
 * @export
 * @interface OrderAttentionItem
 */
export interface OrderAttentionItem {
    /**
     * 
     * @type {string}
     * @memberof OrderAttentionItem
     */
    kind: OrderAttentionItemKindEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderAttentionItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttentionItem
     */
    orderCode: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttentionItem
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttentionItem
     */
    storeName: string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderAttentionItem
     */
    status: OrderStatus;
    /**
     * 
     * @type {Date}
     * @memberof OrderAttentionItem
     */
    occurredAt: Date;
    /**
     * 
     * @type {number}
     * @memberof OrderAttentionItem
     */
    hoursWaiting?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAttentionItem
     */
    incompleteDeliveryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAttentionItem
     */
    incompleteReason?: OrderAttentionItemIncompleteReasonEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof OrderAttentionItem
     */
    lastStatusChangedAt?: Date | null;
}


/**
 * @export
 */
export const OrderAttentionItemKindEnum = {
    IncompleteDelivery: 'INCOMPLETE_DELIVERY',
    UnactionedOrder: 'UNACTIONED_ORDER'
} as const;
export type OrderAttentionItemKindEnum = typeof OrderAttentionItemKindEnum[keyof typeof OrderAttentionItemKindEnum];

/**
 * @export
 */
export const OrderAttentionItemIncompleteReasonEnum = {
    ItemsMissing: 'ITEMS_MISSING',
    ItemDamaged: 'ITEM_DAMAGED',
    Other: 'OTHER'
} as const;
export type OrderAttentionItemIncompleteReasonEnum = typeof OrderAttentionItemIncompleteReasonEnum[keyof typeof OrderAttentionItemIncompleteReasonEnum];


/**
 * Check if a given object implements the OrderAttentionItem interface.
 */
// @ts-ignore
export function instanceOfOrderAttentionItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "kind" in value;
    isInstance = isInstance && "orderId" in value;
    isInstance = isInstance && "orderCode" in value;
    isInstance = isInstance && "storeId" in value;
    isInstance = isInstance && "storeName" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "occurredAt" in value;

    return isInstance;
}

// @ts-ignore
export function OrderAttentionItemFromJSON(json: any): OrderAttentionItem {
    return OrderAttentionItemFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderAttentionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderAttentionItem {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'orderId': json['order_id'],
        'orderCode': json['order_code'],
        'storeId': json['store_id'],
        'storeName': json['store_name'],
        'status': OrderStatusFromJSON(json['status']),
        'occurredAt': (new Date(json['occurred_at'])),
        'hoursWaiting': !exists(json, 'hours_waiting') ? undefined : json['hours_waiting'],
        'incompleteDeliveryId': !exists(json, 'incomplete_delivery_id') ? undefined : json['incomplete_delivery_id'],
        'incompleteReason': !exists(json, 'incomplete_reason') ? undefined : json['incomplete_reason'],
        'lastStatusChangedAt': !exists(json, 'last_status_changed_at') ? undefined : (json['last_status_changed_at'] === null ? null : new Date(json['last_status_changed_at'])),
    };
}

// @ts-ignore
export function OrderAttentionItemToJSON(value?: OrderAttentionItem | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kind': value.kind,
        'order_id': value.orderId,
        'order_code': value.orderCode,
        'store_id': value.storeId,
        'store_name': value.storeName,
        'status': OrderStatusToJSON(value.status),
        'occurred_at': (value.occurredAt.toISOString()),
        'hours_waiting': value.hoursWaiting,
        'incomplete_delivery_id': value.incompleteDeliveryId,
        'incomplete_reason': value.incompleteReason,
        'last_status_changed_at': value.lastStatusChangedAt === undefined ? undefined : (value.lastStatusChangedAt === null ? null : value.lastStatusChangedAt.toISOString()),
    };
}

